export const METAFIELD_FILTER_PREFIX = 'mf-';
